import { DaymapQuery as d } from "../../daymapQuery.js";
var a;
((e) => {
  class t extends d {
    constructor(s) {
      super(
        ["dashboard", s.studentId, s.from, s.to],
        s,
        `/lms/api/analysis/dashboard?studentId=${s.studentId}&from=${s.from}&to=${s.to}`,
        null,
        { stale: 1e3 * 60, enabled: s.enabled }
        // 1 minute
      );
    }
  }
  e.AssessmentDash = t;
})(a || (a = {}));
export {
  a as analysis
};
//# sourceMappingURL=index.js.map
